export { default as PageNotFound } from './page'


// WEBPACK FOOTER //
// ./src/pages/pageNotFound/index.js